webpackJsonp([114276838955818,60335399758886],{

/***/ 241:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(586);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(241);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	  siteMetadata: {
	    title: 'Siljekvarnsvägen',
	    description: 'Siljekvarnsvägens vägförening.',
	    siteUrl: 'https://siljekvarnsvagen.se',
	    author: 'Siljekvarnsvägen'
	  },
	  pathPrefix: '/',
	  plugins: [{
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      path: __dirname + '/src/pages',
	      name: 'pages'
	    }
	  }, {
	    resolve: 'gatsby-transformer-remark',
	    options: {
	      plugins: [{
	        resolve: 'gatsby-remark-images',
	        options: {
	          maxWidth: 750,
	          linkImagesToOriginal: false,
	          wrapperStyle: 'margin-bottom: 1.0725rem;'
	        }
	      }, {
	        resolve: 'gatsby-remark-responsive-iframe',
	        options: {
	          wrapperStyle: 'margin-bottom: 1.0725rem'
	        }
	      }, 'gatsby-remark-prismjs', 'gatsby-remark-copy-linked-files', 'gatsby-remark-smartypants']
	    }
	  }, {
	    resolve: 'gatsby-plugin-netlify',
	    options: {
	      mergeSecurityHeaders: true,
	      mergeLinkHeaders: true,
	      mergeCachingHeaders: true
	    }
	  }, 'gatsby-plugin-catch-links', 'gatsby-plugin-offline', 'gatsby-plugin-react-helmet', 'gatsby-plugin-react-next', 'gatsby-plugin-sass', 'gatsby-plugin-sharp', 'gatsby-plugin-sitemap', 'gatsby-transformer-sharp']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  // AMD
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory(root);
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node.js or CommonJS
	    module.exports = factory;
	  } else {
	    // Browser globals
	    root.emergence = factory(root);
	  }
	})(this, function(root) {
	
	  'use strict';
	
	  var emergence = {};
	  var poll, container, throttle, reset, handheld, elemCushion, offsetTop, offsetRight, offsetBottom, offsetLeft;
	  var callback = function() {};
	
	  // Browser feature test to include any browser APIs required for >= IE8
	  // @return {bool} true if supported, otherwise false
	  var cutsTheMustard = function() {
	    return 'querySelectorAll' in document ? true : false;
	  };
	
	  // Checks if user is on a handheld
	  // @return {bool} true if it's a handheld, otherwise false
	  var isHandheld = function() {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|playbook|silk/i.test(
	      navigator.userAgent
	    );
	  };
	
	  // Get the offset of a DOM Element
	  // @param {DOMElement} elem the container or element
	  // @return {int} the top, left, width and height values in pixels
	  var getElemOffset = function(elem) {
	
	    // Width and height of container or element
	    var w = elem.offsetWidth;
	    var h = elem.offsetHeight;
	
	    // Default top and left position of container or element
	    var topPos = 0;
	    var leftPos = 0;
	
	    // Get total distance of container or element to document's top and left origin
	    do {
	      if (!isNaN(elem.offsetTop)) {
	        topPos += elem.offsetTop;
	      }
	      if (!isNaN(elem.offsetLeft)) {
	        leftPos += elem.offsetLeft;
	      }
	    } while ((elem = elem.offsetParent) !== null);
	
	    // Return dimensions and position
	    return {
	      width: w,
	      height: h,
	      top: topPos,
	      left: leftPos
	    };
	  };
	
	  // Get the custom container size if provided, otherwise the documents
	  // @return {int} the width and height in pixels
	  var getContainerSize = function(container) {
	    var w, h;
	
	    // If custom container is provided in options
	    // Else use window or document
	    if (container !== window) {
	      w = container.clientWidth;
	      h = container.clientHeight;
	    } else {
	      w = window.innerWidth || document.documentElement.clientWidth;
	      h = window.innerHeight || document.documentElement.clientHeight;
	    }
	
	    return {
	      width: w,
	      height: h
	    };
	  };
	
	  // Get the X and Y scroll positions
	  // @return {int} the X and Y values in pixels
	  var getContainerScroll = function(container) {
	
	    // If custom container is provided in options
	    // Else use window or document
	    if (container !== window) {
	      return {
	        x: container.scrollLeft + getElemOffset(container).left,
	        y: container.scrollTop + getElemOffset(container).top
	      };
	    } else {
	      return {
	        x: window.pageXOffset || document.documentElement.scrollLeft,
	        y: window.pageYOffset || document.documentElement.scrollTop
	      };
	    }
	  };
	
	  // Check if element's closest parent is hidden (display: none)
	  // @param {DOMElement} elem the element
	  // @return {bool} true if hidden, false otherwise
	  var isHidden = function(elem) {
	    return elem.offsetParent === null;
	  };
	
	  // Check if element is visible
	  // @param {DOMElement} elem the element
	  var isVisible = function(elem) {
	
	    // Discontinue if element's closest parent is hidden
	    if (isHidden(elem)) {
	      return false;
	    }
	
	    // Get information from element and container
	    var elemOffset = getElemOffset(elem);
	    var containerSize = getContainerSize(container);
	    var containerScroll = getContainerScroll(container);
	
	    // Determine element size
	    var elemWidth = elemOffset.width;
	    var elemHeight = elemOffset.height;
	
	    // Determine element position from rect points
	    var elemTop = elemOffset.top;
	    var elemLeft = elemOffset.left;
	    var elemBottom = elemTop + elemHeight;
	    var elemRight = elemLeft + elemWidth;
	
	    // Determine boundaries of container and element
	    // @return {bool} true if element is found within boundaries, otherwise false
	    var checkBoundaries = function() {
	
	      // Determine element boundaries including custom cushion
	      var eTop = elemTop + elemHeight * elemCushion;
	      var eRight = elemRight - elemWidth * elemCushion;
	      var eBottom = elemBottom - elemHeight * elemCushion;
	      var eLeft = elemLeft + elemWidth * elemCushion;
	
	      // Determine container boundaries including custom offset
	      var cTop = containerScroll.y + offsetTop;
	      var cRight = containerScroll.x - offsetRight + containerSize.width;
	      var cBottom = containerScroll.y - offsetBottom + containerSize.height;
	      var cLeft = containerScroll.x + offsetLeft;
	
	      return (eTop < cBottom && eBottom > cTop && eLeft < cRight && eRight > cLeft);
	    };
	
	    return checkBoundaries();
	  };
	
	  // Engage emergence through a throttling method for performance
	  var emergenceThrottle = function() {
	    if (!!poll) {
	      return;
	    }
	    clearTimeout(poll);
	    poll = setTimeout(function() {
	      emergence.engage();
	      poll = null;
	    }, throttle);
	  };
	
	  // Initialize emergence with options, do feature test and create event listeners
	  // @param {Object} options Custom settings
	  emergence.init = function(options) {
	    options = options || {};
	
	    // Function to return an integer
	    var optionInt = function(option, fallback) {
	      return parseInt(option || fallback, 10);
	    };
	
	    // Function to return a floating point number
	    var optionFloat = function(option, fallback) {
	      return parseFloat(option || fallback);
	    };
	
	    // Default options
	    container = options.container || window; // window or document by default
	    reset = typeof options.reset !== 'undefined' ? options.reset : true; // true by default
	    handheld = typeof options.handheld !== 'undefined' ? options.handheld : true; // true by default
	    throttle = optionInt(options.throttle, 250); // 250 by default
	    elemCushion = optionFloat(options.elemCushion, 0.15); // 0.15 by default
	    offsetTop = optionInt(options.offsetTop, 0); // 0 by default
	    offsetRight = optionInt(options.offsetRight, 0); // 0 by default
	    offsetBottom = optionInt(options.offsetBottom, 0); // 0 by default
	    offsetLeft = optionInt(options.offsetLeft, 0); // 0 by default
	    callback = options.callback || callback;
	
	    // If browser doesn't pass feature test
	    if (!cutsTheMustard()) {
	
	      // Provide message in console.log
	      console.log('Emergence.js is not supported in this browser.');
	
	    }
	    // If this is handheld device AND handheld option is true
	    // OR not a handheld device
	    else if ((isHandheld() && handheld) || !isHandheld()) {
	
	      // Add '.emergence' class to document for conditional CSS
	      document.documentElement.className += ' emergence';
	
	      // If browser supports addEventListener
	      // Else use attachEvent
	      if (window.addEventListener) {
	
	        // Add event listeners for load, scroll and resize events
	        window.addEventListener('load', emergenceThrottle, false);
	        container.addEventListener('scroll', emergenceThrottle, false);
	        container.addEventListener('resize', emergenceThrottle, false);
	
	      } else {
	
	        // Attach events for legacy load method, scroll and resize events
	        document.attachEvent('onreadystatechange', function() {
	          if (document.readyState === 'complete') { emergenceThrottle(); }
	        });
	        container.attachEvent('onscroll', emergenceThrottle);
	        container.attachEvent('onresize', emergenceThrottle);
	
	      }
	    }
	  };
	
	  // Engage emergence
	  emergence.engage = function() {
	    var nodes = document.querySelectorAll('[data-emergence]');
	    var length = nodes.length;
	    var elem;
	
	    // Loop through objects with data-emergence attribute
	    for (var i = 0; i < length; i++) {
	      elem = nodes[i];
	
	      // If element is visible
	      if (isVisible(elem)) {
	
	        // Change the state of the attribute to 'visible'
	        elem.setAttribute('data-emergence', 'visible');
	
	        // Hack to repaint attribute in IE8
	        elem.className = elem.className;
	
	        // Callback for when element is visible
	        callback(elem, 'visible');
	
	      } else if (reset === true) {
	
	        // Else if element is hidden and reset
	        // Change the state of the attribute to 'hidden'
	        elem.setAttribute('data-emergence', 'hidden');
	
	        // Hack to repaint attribute in IE8
	        elem.className = elem.className;
	
	        // Create callback
	        callback(elem, 'reset');
	
	      } else if (reset === false) {
	
	        // Else if element is hidden and NOT reset
	        // Create callback
	        callback(elem, 'noreset');
	
	      }
	    }
	    
	    // If no data-emergence attributes are found
	    // Disengage emergence
	    if (!length) {
	      emergence.disengage();
	    }
	  };
	
	  // Disengage emergence
	  emergence.disengage = function() {
	
	    // If browser supports removeEventListener
	    // Else use detachEvent
	    if (window.removeEventListener) {
	
	      // Remove event listeners scroll and resize events
	      container.removeEventListener('scroll', emergenceThrottle, false);
	      container.removeEventListener('resize', emergenceThrottle, false);
	
	    } else {
	
	      // Detach scroll and resize events
	      container.detachEvent('onscroll', emergenceThrottle);
	      container.detachEvent('onresize', emergenceThrottle);
	
	    }
	
	    // Clear timeout from throttle
	    clearTimeout(poll);
	  };
	
	  return emergence;
	});


/***/ }),

/***/ 889:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.
	
	// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
	// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
	// copy, distribute and modify it.
	
	// AWS Mobile Hub Project Constants
	var awsmobile = {
	    'aws_app_analytics': 'enable',
	    'aws_cognito_identity_pool_id': 'eu-west-1:26b572f3-fe3f-4824-a20e-1b5ec64e232f',
	    'aws_cognito_region': 'eu-west-1',
	    'aws_content_delivery': 'enable',
	    'aws_content_delivery_bucket': 'silje-hosting-mobilehub-940232879',
	    'aws_content_delivery_bucket_region': 'eu-west-1',
	    'aws_content_delivery_cloudfront': 'enable',
	    'aws_content_delivery_cloudfront_domain': 'd1viu6kvd51kr2.cloudfront.net',
	    'aws_mobile_analytics_app_id': 'ab19053e29924ab5837eea5bb83d75b3',
	    'aws_mobile_analytics_app_region': 'us-east-1',
	    'aws_project_id': '2512c903-7608-4fec-9ba5-6390dbac56c6',
	    'aws_project_name': 'Silje',
	    'aws_project_region': 'eu-west-1',
	    'aws_resource_name_prefix': 'silje-mobilehub-940232879',
	    'aws_sign_in_enabled': 'enable',
	    'aws_user_pools': 'enable',
	    'aws_user_pools_id': 'eu-west-1_AW8wCegPs',
	    'aws_user_pools_mfa_type': 'OFF',
	    'aws_user_pools_web_client_id': '4lsm7jl9uhlnt1vlvgu92oruc'
	};
	
	exports.default = awsmobile;
	module.exports = exports['default'];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(51);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRedux = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoggedInAs = function LoggedInAs(_ref) {
	  var user = _ref.user,
	      logout = _ref.logout;
	
	  if (user === null) {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/inloggning', className: 'btn btn-secondary btn-sm' },
	      'Logga in'
	    );
	  }
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    'Inloggad som ',
	    _react2.default.createElement(
	      'strong',
	      null,
	      user.username
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      'button',
	      { onClick: logout, className: 'btn btn-outline-secondary btn-sm' },
	      'Logga ut'
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var user = _ref2.user;
	
	  return { user: user };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { logout: function logout() {
	      return dispatch({ type: 'LOGOUT_REQUESTED' });
	    } };
	};
	
	var ConnectedLoggedInAs = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoggedInAs);
	
	var SiteNavi = function (_React$Component) {
	  _inherits(SiteNavi, _React$Component);
	
	  function SiteNavi() {
	    _classCallCheck(this, SiteNavi);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SiteNavi.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        title = _props.title;
	
	    return _react2.default.createElement(
	      'nav',
	      { className: 'navbar navbar-expand navbar-dark flex-column flex-md-row bg-primary' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'text-center', to: '/' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'navbar-brand mb-0' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'navbar-nav-scroll' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'navbar-nav bd-navbar-nav flex-row' },
	            _react2.default.createElement(
	              'li',
	              {
	                className: location.pathname === '/' ? 'nav-item active' : 'nav-item'
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/', className: 'nav-link' },
	                'Start'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              {
	                className: location.pathname === '/om/' ? 'nav-item active' : 'nav-item'
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/om/', className: 'nav-link' },
	                'Om'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              {
	                className: location.pathname === '/nyheter/' ? 'nav-item active' : 'nav-item'
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/nyheter/', className: 'nav-link' },
	                'Nyheter'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'navbar-text' },
	          _react2.default.createElement(ConnectedLoggedInAs, null)
	        )
	      ),
	      _react2.default.createElement('div', { className: 'navbar-nav flex-row ml-md-auto d-none d-md-flex' })
	    );
	  };
	
	  return SiteNavi;
	}(_react2.default.Component);
	
	exports.default = SiteNavi;
	module.exports = exports['default'];

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(51);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyConfig = __webpack_require__(186);
	
	var _SiteNavi = __webpack_require__(584);
	
	var _SiteNavi2 = _interopRequireDefault(_SiteNavi);
	
	var _emergence = __webpack_require__(885);
	
	var _emergence2 = _interopRequireDefault(_emergence);
	
	var _awsAmplify = __webpack_require__(326);
	
	var _awsAmplify2 = _interopRequireDefault(_awsAmplify);
	
	var _awsExports = __webpack_require__(583);
	
	var _awsExports2 = _interopRequireDefault(_awsExports);
	
	__webpack_require__(1023);
	
	__webpack_require__(887);
	
	__webpack_require__(890);
	
	__webpack_require__(888);
	
	__webpack_require__(889);
	
	var _reactRedux = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dict = {
	  sv: {
	    'Sign In': 'Logga in',
	    'Sign Up': 'Registrera',
	    'Sign Out': 'Logga ut',
	    'Forgot Password': 'Glömt lösenord',
	    'Username cannot be empty': 'Användarnamn kan inte vara tomt',
	    'User does not exist.': 'Användaren finns inte.',
	    Username: 'Användarnamn',
	    Password: 'Lösenord',
	    'Change Password': 'Byt lösenord',
	    'New Password': 'Nytt lösenord',
	    Email: 'Epost',
	    'Phone Number': 'Telefonnummer',
	    'Confirm a Code': 'Bekräfta kod',
	    'Confirm Sign In': 'Bekräfta inloggning',
	    'Confirm Sign Up': 'Bekräfta registrering',
	    'Back to Sign In': 'Tillbaks till inloggning',
	    'Send Code': 'Skicka kod',
	    Confirm: 'Bekräfta',
	    'Resend a Code': 'Skicka kod igen',
	    Submit: 'Skicka',
	    Skip: 'Hoppa över',
	    Verify: 'Verifiera',
	    'Verify Contact': 'Verifiera kontakt',
	    Code: 'Kod',
	    'Account recovery requires verified contact information': 'Återställning av konto kräver verifierad kontaktinformation',
	
	    'User does not exist': 'Användaren finns inte',
	    'User already exists': 'Användaren finns redan',
	    'Incorrect username or password': 'Ogiltigt användarnamn eller lösenord',
	    'Invalid password format': 'Ogiltigt lösenordsformat',
	    'Invalid phone number format': 'Ogiltigt telefonnummer'
	  }
	};
	
	_awsAmplify2.default.configure(_awsExports2.default);
	_awsAmplify.I18n.putVocabularies(dict);
	_awsAmplify.I18n.setLanguage('sv');
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    _awsAmplify.Auth.currentAuthenticatedUser().then(function (user) {
	      return _this2.props.user(user);
	    }).catch(function (err) {
	      return console.error('could not get current user', err);
	    });
	  };
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    _emergence2.default.init();
	  };
	
	  Template.prototype.componentDidUpdate = function componentDidUpdate() {
	    _emergence2.default.init();
	  };
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SiteNavi2.default, _extends({ title: _gatsbyConfig.siteMetadata.title }, this.props)),
	      children()
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var count = _ref.count;
	
	  return { count: count };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return { user: function user(_user) {
	      return dispatch({ type: 'USER', user: _user });
	    } };
	};
	
	var ConnectedTemplate = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Template);
	
	exports.default = ConnectedTemplate;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6cfa1fdcc2281f455e17.js